import * as React from 'react';
import { clsx } from 'clsx';
import styles from './error-wrapper.module.scss';

type ErrorWrapperProps = {
  className?: string;
};

export const ErrorWrapper: React.FC<React.PropsWithChildren<ErrorWrapperProps>> = ({
  className,
  children
}) => <fieldset className={clsx([styles.errorWrapper, className])}>{children}</fieldset>;
